export const ERROR_TYPE = 'error';

export const TEST_ID = 'exportDropdown';
